import { useFormBuilderContext } from 'lib/context/FormBuilder/FormBuilderContext';

import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';

const EmptyFormsPlaceholder = () => {
  const { setOpenModal } = useFormBuilderContext();
  return (
    <>
      <div className="flex w-full flex-col items-center pb-20">
        <Icon icon="illustration-empty-table" />
        <h1 className="text-base font-500 text-primary-900">No clinical forms added</h1>
        <Button
          className="mt-4"
          textClassName="whitespace-nowrap"
          text="Add new form"
          icon="add-square-mono"
          size="xs"
          variant="link"
          onClick={() => {
            setOpenModal(true);
          }}
        />
      </div>
    </>
  );
};
export default EmptyFormsPlaceholder;
